import { useState, useEffect, useRef } from 'react';
import Bredcrum from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import { Tablescom } from '../../components/tablescomp';
import { userservices } from '../../services/userServices';
import { productservices } from '../../services/productServices';
import { Titlebar, Searchbox, Stockstatus, Stockstatusavailability, Importexceldata,Confirmdialog2,Orderstatus } from '../../components/fieldsComp';

import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router";
import { supplierservices } from '../../services/supplierServices'
import { StockServices } from '../../services/stockServices';
import { Dialog } from 'primereact/dialog';
import { TabMenu } from 'primereact/tabmenu';
import { exportToExcel } from '../../helpers/exporttoexcel';
import { Toast } from "primereact/toast";
import { convertFileToBase64 } from '../../helpers/base64conversion';
import { FcRefresh } from "react-icons/fc";
import { AiOutlineRetweet } from "react-icons/ai";
import { saleServices } from '../../services/saleServices';

const Salesreports = ({ dashboard = false }) => {
  const toast = useRef(null);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [results, setResults] = useState([]);
  const [userloaded, setUserloaded] = useState(true);
  const [stockdialog, setStockDialog] = useState(false);
  const [detailinfo, setDetailinfo] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // 🔄 dynamic page size
  const [quickFilterText, setQuickFilterText] = useState('');
  const [statusset, setStatusset] = useState('Delivered');
  const [visible, setVisible] = useState(false);
  const [popvisible, setPopvisible] = useState(false);
  const [viewvisible, setViewvisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [salesTotal , setSalesTotal] = useState('');
  const gridref = useRef();
  

  const items = [
    // {
    //   label: 'Merged',
    //   icon: 'fa fa-angle-right',
    //   command: () => handleStockFilter('merged'),
    //   // template: (item) => itemRenderer(item, 0)
    // },
    {
      label: 'All Sales',
      icon: 'fa fa-angle-right', 
      command: () => handleStockFilter('all'),
      // template: (item) => itemRenderer(item, 0)
    },
    // {
    //   label: 'Open',
    //   icon: 'fa fa-angle-right',
    //   command: () => handleStockFilter('Open'),
    //   //  template: (item) => itemRenderer(item, 1)
    // },
    // {
    //   label: 'Confirmed',
    //   icon: 'fa fa-angle-right',
    //   command: () => handleStockFilter('Confirmed'),
    //   //  template: (item) => itemRenderer(item, 1)
    // },
    // {
    //   label: 'Packed',
    //   icon: 'fa fa-angle-right',
    //   command: () => handleStockFilter('Packed'),
    //   //  template: (item) => itemRenderer(item, 2)
    // },
    
    {
      label: 'Shipped',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Shipped'),
      //  template: (item) => itemRenderer(item, 3)
    },
    {
      label: 'Delivered',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Delivered'),
      //  template: (item) => itemRenderer(item, 3)
    },
    {
      label: 'Closed',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Closed'),
      //  template: (item) => itemRenderer(item, 3)
    },
    // {
    //   label: 'Cancelled',
    //   icon: 'fa fa-angle-right',
    //   command: () => handleStockFilter('Cancelled'),
    //   //  template: (item) => itemRenderer(item, 3)
    // }
  ];


  function handleStockFilter(status) {
    setStatusset(status);
    salesReport();
  }


  useEffect(() => {
    salesReport();
  }, [statusset, currentPage, pageSize]);

  useEffect(() => {
    setColDefs(getColDefs(currentPage, pageSize));
  }, [statusset, currentPage, pageSize]);

  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const getColDefs = (currentPage, pageSize) => [
    {
      headerName: "SR NO", field: "id", width: 50,
      valueGetter: (params) => {
        return ((currentPage - 1) * pageSize) + params.node.rowIndex + 1;
      },
    },
    
    {
      headerName: "Order No", field: "order_id"
    },
    { headerName: "Product", field: "product_name",cellStyle: {
        whiteSpace: 'normal',
        lineHeight: '1.4',
        wordBreak: 'break-word',
        display: 'flex',
        alignItems: 'center'
      }, },
       
      ...(statusset === 'merged'
    ? [{ headerName: "Total Stock", field: "total_stock", width:100

      }]
    : []),
      { headerName: "Units Sold", field: "units_sold", width:100,
      valueGetter: (params) => {
          return params.data.totalunits_sold ?? params.data.units_sold ?? 0;
        }
      },
      
    //   ...(statusset === 'merged'
    // ? [{ headerName: "Remain Stock", field: "remainqty",width:100 }]
    // : []),
      
        {
      headerName: "SPU", field: "sales_price"
    },
    {
      headerName: "Total sales", field: "total_sale"
    },

   
    {
      headerName: "Sales Channel", field: "sales_channel"
    },
    {
      headerName:"Sales Date",field:"sales_date"
    },
    {
      headerName: "Status", field: "order_status",cellRenderer: (params) => {
          return <Orderstatus status={params.getValue()} />
      }
    },
     {
      headerName: "Customer", field: "customer_name"
    },
     {
      headerName: "Email", field: "customer_email"
    },
     {
      headerName: "Mobile no", field: "customer_mobile"
    },
    
 ];
  const [colDefs, setColDefs] = useState(getColDefs(1, 5));

  const getRowClass = params => {
    if (params.data.Instock === 'lowstock') {
      return 'low-stock';
    } else if (params.data.Instock === 'instock') {
      return 'in-stock';
    } else if (params.data.Instock === 'outofstock') {
      return 'out-of-stock';
    }
    else if (params.data.Instock === 'overstock') {
      return 'over-stock';
    }
    return '';
  };

  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    salesReport();      // reload with new size
  };

  
  const onHide = () => {
    setVisible(false);
  };
  useEffect(()=>{
    salesReport(); 
  },[statusset])

  const salesReport = () =>{
      setUserloaded(true);
      saleServices.salesReport({status:statusset,page:currentPage,limit:pageSize}).then((response)=>{
         if(response.status == 200){
            // console.log(response.data.data);
            setResults(response.data.data);
            setUserloaded(false);
            setTotalRows(response.data.total);
            const newResults = response.data.data;
            calculateTotalSales(newResults);
         }else{
            setResults([]);
            setUserloaded(false);
            setTotalRows(0);
         }
      }).catch((error)=>{
          setResults([]);
          setUserloaded(false);
          setTotalRows(0);
      })
  }

  const calculateTotalSales = (data) => {
      console.log("Result data : ", data);
       let finalTotal = 0;
            data.forEach(element => {
              let totalSale = parseInt(element.total_sale);
              // console.log("Sale total sales", element.total_sale);
              finalTotal = finalTotal + totalSale;
            });
        setSalesTotal(finalTotal);
  }

  const uploaddata = async (e) => {
    e.preventDefault();
    setLoading(true); // show loader
    let file = e.target.file.files[0];
    const base64 = await convertFileToBase64(file);
    StockServices.createmultistockupdate(base64).then((response) => {
      if (response.status == 200) {
        setVisible(false);
        setLoading(false); // show loader
        // toast.current.show({ severity: 'success', summary: 'Stock Update', detail: response.data.data });
        // getstocks(statusset, currentPage, pageSize);
      } else {
        // toast.current.show({ severity: 'error', summary: 'Stock Update', detail: `${response.data.data}` });
        setVisible(false);
        setLoading(true); // show loader
      }
    }).catch((error) => {

    });
  }


  const handleExport = () => {
    exportToExcel({ data: results, filename: 'stock' });
  }
  const samplepath = "stockupdate.xlsx";
  return (
    <>
      <Toast ref={toast} />
      <Importexceldata
        visible={visible}
        onHide={onHide}
        onSubmit={uploaddata}
        samplepath={samplepath}
        loading={loading}
      />

      {dashboard ? (<>
        <div className="col-md-12 mt-3">
          {/* <div className='row'>
            <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
          </div> */}
          <div className='card'>
            <div className='card-body card-body-style'>
              {/* {DisplayComp(activeIndex)} */}
              <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText} paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                handlePrevious={handlePrevious}
                handlePageSizeChange={handlePageSizeChange} gridref={gridref} getRowClass={getRowClass} />
            </div>
          </div>
        </div>
      </>) : (<>
      {/* <Bredcrum title={'Sales Report'} divider={false} /> */}
        <div class="row">
          {/* <Titlebar text={'Sales Report'} /> */}
          <div className="col-md-12 mt-3">
            <div className='row'>
              <div className='col-md-6'>
                <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
              </div>
              <div className='col-md-3 '>
                <div className='card pb-0'>
                    <div className='card-header card-header-style'>
                      <h5>Total Sales : {salesTotal}</h5>
                    </div>
                </div>
              </div>
              <div className='col-md-3'>
                <div>
                  <button class="export-btn form-control w-50 pull-right" onClick={() => handleExport()}>
                    <i className='fa fa-file-excel'></i> &nbsp;Export to Excel</button>
                </div>
              </div>
            </div>
            <div className='card'>
              <div className='card-body card-body-style'>
                {/* {DisplayComp(activeIndex)} */}
                <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText} paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                  totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                  handlePrevious={handlePrevious}
                  handlePageSizeChange={handlePageSizeChange} gridref={gridref} getRowClass={getRowClass} />
              </div>
            </div>
          </div>
        </div></>)}
    </>
 );
}
export default Salesreports;